export default __webpack_public_path__ + "static/media/floating-msgIcon.483e9df7.svg";